import { render, staticRenderFns } from "./TitlePage.vue?vue&type=template&id=6e1dd7b8&scoped=true&"
import script from "./TitlePage.vue?vue&type=script&lang=js&"
export * from "./TitlePage.vue?vue&type=script&lang=js&"
import style0 from "./TitlePage.vue?vue&type=style&index=0&id=6e1dd7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1dd7b8",
  null
  
)

export default component.exports